angular.module('gym.components').directive('reportMonthFilter', function() {
  return {
    restrict: 'E',
    template: require('templates/components/reports/report_month_filter.html.slim'),
    controller: ["$scope", "Months", function($scope, Months) {
      return $scope.months = Months;
    }]
  };
});
